export const EPPO_API_KEY =
    process.env.REACT_APP_EPPO_API_KEY || "sL9Y8bA2oRzNCKoend4Do6ZYsofP-Kq1nv0gyjAyvp4";
